import * as constants from '../constants';
import { SettingActions } from '../interfaces/actions';

export function updateSettings(dashboardRefresh: number): SettingActions {
    return { 
        type: constants.SET_DATA_REFRESH_TIME, 
        dashboardRefresh,
    }
}

export function setMapRefreshRate(mapRefreshRate: string): SettingActions {
    return {
        type: constants.SET_MAP_REFRESH_RATE,
        mapRefreshRate,
    }
}

export type settingActions = SettingActions;